<template>
  <div class="wrapper">
    <div class="fixed">
      <div class="lateral-sliding" v-show="starttime.length > 0" id="lateralScroll">
        <div :id="'lateralItem'+index" class="lateral-sliding-item" v-for="(item,index) in starttime" :key="index">
          <div :class="index==isindex  ? 'each-img' : 'each-img-x'" @click="chuxian(index) ">
            <span class="each-img-span">{{item.start_time}}</span>
            <br />
            <div class="each-img-span1" v-if="nbr == '1' &&type == '1'">
              <span v-if="item.isEnd">已结束</span>
              <span v-else-if="item.timeText == true ">抢购中</span>
              <span v-else-if="item.timeText == false">即将开抢</span>
              <span v-else-if="item.tomorrow == true">明日预告</span>
            </div>
            <div class="each-img-span1" v-if="nbr == '1' &&type == '2'">
              <span v-if="item.timeText == true ">抢购中</span>
              <span v-else-if="item.timeText == false">即将开抢</span>
              <span v-else-if="item.tomorrow == true">明日预告</span>
            </div>
            <div class="each-img-span1" v-if="nbr == '2'&&type == '2'">
              <span>明日预告</span>
            </div>
            <div :class="index==isindex?'active':''">
              <span class="span"></span>
            </div>
          </div>
          <i
            class="xianC"
            v-show="index!=starttime.length -1"
          ><div class="xian"></div></i>
        </div>
      </div>
      <div class="line" v-if="commodity_startTime.length > 0"></div>
    </div>
    <div class="time" v-if="starttime.length > 0 && commodity_startTime.length > 0">
      <span v-if="starttime[isindex].timeText == true " class="timespan">距本场结束还剩：</span>
      <span v-else class="timespan">距离本场秒杀开始还剩：</span>
      <div class="times">
        <span v-if="countdown.split(':')[0] != '00'">{{countdown.split(':')[0]}}</span>
        <i v-if="countdown.split(':')[0] != '00'">天</i>
        <span>{{countdown.split(":")[1]}}</span>
        <i>:</i>
        <span>{{countdown.split(":")[2]}}</span>
        <i>:</i>
        <span>{{countdown.split(":")[3]}}</span>
      </div>
      <!-- <span v-if="starttime[isindex].timeText == false || starttime[isindex].tomorrow == false" class="timespan">距离本场秒杀开始还剩：</span>
      <div v-if="starttime[isindex].timeText == false  || starttime[isindex].tomorrow == false " class="times">
        <span v-if="soonTime.split(':')[0] != '00'">{{soonTime.split(':')[0]}}</span>
        <i v-if="soonTime.split(':')[0] != '00'">天</i>
        <span>{{soonTime.split(":")[1]}}</span>
        <i>:</i>
        <span>{{soonTime.split(":")[2]}}</span>
        <i>:</i>
        <span>{{soonTime.split(":")[3]}}</span>
      </div> -->
    </div>
    <div class="noDota" v-if="commodity_startTime.length == 0&&!commodity_startTime_Loading"><span>该场秒杀已结束</span></div>
    <van-list
        :class="type==-1?'contents':'content'"
        id="scroll"
        v-show="commodity_startTime.length > 0"
        v-model="loading"
        :finished="finished"
        :offset="20"
        @load="getStarttime"
    >
      <div
        class="content-box"
        v-for="(item,index2) in commodity_startTime"
        :key="index2"
        @click="golistdetail(item.nbr, item.rule_type)"
      >
        <div class="content-box-tu">
          <img v-lazy="item.commodity_logo + `${imgCrop}resize,w_500`" alt />
          <div :class="item.quantity==='0'?'noNum':'noNum hide'">
            <img v-lazy="require('../../assets/images/noNum.png')" alt />
          </div>
        </div>
        <div class="content-box-information">
          <div class="home-content-jmrt sigle-twoh">{{ item.commodity_name }}</div>
          <div
            class="home-content-jmrm1 more-h"
            style=" -webkit-box-orient: vertical;"
            v-if="starttime[isindex].timeText == false||starttime[isindex].tomorrow == true"
          >
            <span>
              <!--剩余{{item.quantity}}件 |-->
              <i v-if="starttime[isindex].tomorrow == true">明日</i>
              <i v-else>今日</i>{{starttime[indexTime].start_time}}开抢
            </span>
          </div>
          <div class="progress" style="background: #fff;" v-if="starttime[isindex].timeText == true">
            <!--<div
              class="progressbg"
              :style="{width:parseInt(Number(item.sales_num) / (Number(item.quantity) + Number(item.sales_num)) * 100)  + '%'}"
            >
              <span
                v-show="parseInt(Number(item.sales_num) / (Number(item.quantity) + Number(item.sales_num)) * 100) < 95"
              >已抢{{parseInt(Number(item.sales_num) / (Number(item.quantity) + Number(item.sales_num)) * 100)}}%</span>
              <span
                v-show="parseInt(Number(item.sales_num) / (Number(item.quantity) + Number(item.sales_num)) * 100) < 100 && parseInt(Number(item.sales_num) / (Number(item.quantity) + Number(item.sales_num)) * 100) >= 95"
              >即将售罄</span>
              <span
                v-show="(parseInt(Number(item.sales_num) / (Number(item.quantity) + Number(item.sales_num)) * 100) >= 100)||item.quantity==0&&item.sales_num==0"
              >已售罄</span>
            </div>-->
          </div>
          <div class="home-content-jmrm2">
            <span class="msj" v-if="item.rule_type=='2'">
              <i>￥</i>{{roleNewText.toLocaleLowerCase()=='sell'&&item.show_price?item.show_price:item[`min_${roleNewText}_price`]}}
            </span>
            <span class="msj" v-else>
              <i>￥</i>{{roleText.toLocaleLowerCase()=='sell'&&item.show_price?item.show_price:item[`min_${roleText}_price`]}}
            </span>
            <!-- <span class="msj3" v-if="item[`min_sell_price`] - item[`min_${roleText.toLowerCase()}_price`]!=0">
              <span>/</span>
              <span>赚￥{{Math.round((item[`min_sell_price`] - item[`min_${roleText.toLowerCase()}_price`])*100)/100}}</span>
            </span> -->
            <span
              class="msj1"
              @click="golistdetail(item.nbr, item.rule_type)"
              v-if="starttime[isindex].timeText == true && item.quantity >0"
            ><span style="margin-left:.1rem">马上抢<img src="../../assets/images/index/back.svg" /></span></span>
            <span
              class="msj1"
              @click="golistdetail(item.nbr, item.rule_type)"
              v-if="starttime[isindex].timeText == true && item.quantity == 0"
            >查看</span>
            <div @click.stop="noticeThis(item.nbr,index2)" class="msj1 msj99" v-if="starttime[isindex].timeText == false&&(item.warn==0||isLogin == 0) ||starttime[isindex].tomorrow == true&&(item.warn==0||isLogin == 0)">
              <span>设置提醒</span>
            </div>
            <div class="msj2" v-else-if="starttime[isindex].timeText == false&&item.warn!=0 ||starttime[isindex].tomorrow == true&&item.warn!=0">
              <span>已设置</span>
            </div>
          </div>
          <span class="home-content-jmrb">
            <i>￥</i>{{item.old_price}}
          </span>
        </div>
      </div>
    </van-list>
    <!--回到顶部-->
    <div class="toTop" @click="toTopAnimate" v-show="toTopShow">
      <img src="../../assets/images/index/top.svg" />
    </div>
    <div class="noData" v-show="starttime.length == 0 && !noData">
      <img src="../../assets/images/turn/noData.png" alt />
      <span>暂无秒杀商品</span>
    </div>
  </div>
</template>
<script>
import weChatShareApi from "../../assets/js/weChatShare";

export default {
  components: {},
  props: {},
  mixins: [weChatShareApi],
  data() {
    return {
      nbr: "1",
      type: "-1",
      title: "",
      num: 1,
      isindex: "0",
      starttime: [],
      noData: true,
      commodity_startTime: [],
      roleText: "sell", //用户身份文本
      roleNewText: "sell",
      keepAlive: true,
      toTopShow: false,
      countdown: "",
      soonTime: "",
      indexTime: 0,
      tomorrowTime:[],
      lengths:0,
      claerTimer:null,
      isStart:0,
      movetimer:null,
      getTime:'',
      loading:false,
      finished:true,
      pageIndex:0,
      numPerPage:10,
      isLogin:0,
      commodity_startTime_Loading:true,
    };
  },
  methods: {
    initPage(){
      let option = {
        title: '有米@'+this.userInfo.name + "的店铺",
        desc: "欢迎光临我的店铺",
        link: location.origin + "/?supNbr=" + this.userInfo.nbr,
        images: this.userInfo.imgUrl
      };
      this.isLogin = 1;
      this.weChatShare(option);
      this.getUserInfo();
    },
    chuxian(index) {
      if(this.loading){
        return false;
      }
       if(document.title == "明日预告"){
         
       }else{
        if(index >= this.lengths){
          this.type = 2;
        }else{
          this.type = 1;
        }
       }
      this.indexTime = index;
      this.commodity_startTime = [];
      this.isindex = index;
      this.pageIndex = 0;
      this.commodity_startTime_Loading = true;
      this.getStarttime();
    },
    //设置提醒
    noticeThis(nbr,index){
      // return false;
      this.$commonPost({
          jydm: "flow_10000",
          flow_10000: {
            sub_flow: "flow_70122",
            user_nbr: this.userInfo.nbr,
            commodity_nbr: nbr
          }
      })
      .then(response => {
        this.$toast({
          message: '开抢前五分钟提醒你哦',
          duration: 2000
        });
        this.commodity_startTime[index].warn = 1;
      })
      .catch(err => {
        this.$toast({
          message: err.message,
          duration: 2000
        });
      });
    },
    golistdetail(nbr, rule_type) {
      if(rule_type=='2'){
        this.$router.push({ path: "/sourceListdetail", query: { nbr: nbr,supNbr:this.userInfo.nbr } });
      }else{
        this.$router.push({ path: "/listdetail", query: { nbr: nbr,supNbr:this.userInfo.nbr } });
      }
    },
    times() {
      let date = new Date();
      let date1 = new Date();
      let string = this.starttime;
      let thisTimes = `${date1.getFullYear()}/${date1.getMonth() +
        1}/${date1.getDate()} ${date1.getHours()}:${date1.getMinutes()}:${date1.getSeconds()}`;
      let starttimes = thisTimes.replace(/\-/g, "/");
      string[this.isindex].end_time = string[this.isindex].end_time.replace(/\-/g, "/");
      if (date1.getDate() < 10) {
        var newStr =
          starttimes.slice(0, 9) +
          ' ' + string[this.isindex].start_time +
          ":00"
      } else {
        var newStr =
          starttimes.slice(0, 10) + ' ' +
          string[this.isindex].start_time +
          ":00"
      }
      let thisTime = `${date.getFullYear()}/${date.getMonth() +
        1}/${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
      let timeTampStart = parseInt(new Date(newStr) - new Date(thisTime)) / 1000;
      let timeTampEnd = parseInt(new Date(string[this.isindex].end_time) - new Date(thisTime)) / 1000;
      let timeText = ``;
      if (timeTampStart <= 0 && (string[this.isindex].tomorrow != true&&this.type!=2)) {
        if(timeTampEnd <= 0){
          string[this.isindex].isEnd = true;
          return this.tomorrow();
        }
        timeText = `${this.addZero(
          parseInt(timeTampEnd / (60 * 60 * 24))
        )}:${this.addZero(
          parseInt((timeTampEnd % (60 * 60 * 24)) / (60 * 60))
        )}:${this.addZero(
          parseInt((timeTampEnd % (60 * 60)) / 60)
        )}:${this.addZero(parseInt(timeTampEnd % 60))}`;
        this.isStart = 1;
      } else {
        if(string[this.isindex].tomorrow == true||this.type==2){

           timeTampStart = parseInt(new Date(newStr) - new Date(thisTime)) / 1000 + 24*60*60;
           timeText = `${this.addZero(
            parseInt(timeTampStart / (60 * 60 * 24))
          )}:${this.addZero(
            parseInt((timeTampStart % (60 * 60 * 24)) / (60 * 60))
          )}:${this.addZero(
            parseInt((timeTampStart % (60 * 60)) / 60)
          )}:${this.addZero(parseInt(timeTampStart % 60))}`;
          
        }else{
           if(timeTampStart == 0){
            string[this.isindex].timeText = true;
            return this.tomorrow();
          }
          timeText = `${this.addZero(
          parseInt(timeTampStart / (60 * 60 * 24))
         )}:${this.addZero(
          parseInt((timeTampStart % (60 * 60 * 24)) / (60 * 60))
         )}:${this.addZero(
          parseInt((timeTampStart % (60 * 60)) / 60)
         )}:${this.addZero(parseInt(timeTampStart % 60))}`;
        }
        this.isStart = 0;
      }
      this.countdown = timeText;
    },
    soon() {
      let date = new Date();
      let date1 = new Date();
      let string = this.starttime;
      if ((this.nbr == "2" && this.type == "2") || (this.nbr == "1" && this.type =="2" && this.starttime[this.isindex].tomorrow == true)) {
        var thisTimes = `${date1.getFullYear()}/${date1.getMonth() +
          1}/${date1.getDate() +
          1} ${date1.getHours()}:${date1.getMinutes()}:${date1.getSeconds()}`;
      } else {
        var thisTimes = `${date1.getFullYear()}/${date1.getMonth() +
          1}/${date1.getDate()} ${date1.getHours()}:${date1.getMinutes()}:${date1.getSeconds()}`;
      }
      let starttimes = thisTimes.replace(/\-/g, "/");
      if (thisTimes.slice(7, 9) < 10) {
        var newStr =
          starttimes.slice(0, 9) +
          string[this.isindex].start_time +
          ":00" +
          starttimes.slice(18);
      } else {
        var newStr =
          starttimes.slice(0, 10) +
          string[this.isindex].start_time +
          ":00" +
          starttimes.slice(18);
      }
      let thisTime = `${date.getFullYear()}/${date.getMonth() +
        1}/${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
      let timeTamp = parseInt(new Date(newStr) - new Date(thisTime)) / 1000;
      let timeTexts = ``;
      if (timeTamp <= 0) {
        timeTexts = `00:00:00:00`;
      } else {
        timeTexts = `${this.addZero(
          parseInt(timeTamp / (60 * 60 * 24))
        )}:${this.addZero(
          parseInt((timeTamp % (60 * 60 * 24)) / (60 * 60))
        )}:${this.addZero(
          parseInt((timeTamp % (60 * 60)) / 60)
        )}:${this.addZero(parseInt(timeTamp % 60))}`;
      }
      this.soonTime = timeTexts;
    },
    addZero(num) {
      if (num >= 10) return num;
      else return "0" + num;
    },
    timer() {
      let date = new Date();
      let lengths = this.lengths;
      let starttime = this.starttime;
      let tomorrowTime = this.tomorrowTime;
      let getTime = this.getTime;
      let count = 0;
      if(this.nbr == '2' && this.type == '2'){
         for (var i = 0; i < lengths; i++) {
          let toTime = starttime[i].start_time.split(":");
          starttime[i].timeText = false;
          // count += 1;
        }
      }else{
        for (var i = 0; i < lengths; i++) {
          let toTime = starttime[i].start_time.split(":");
          let thisTime = [date.getHours(), date.getMinutes()];
          if(getTime){
            let thisGetTime = [getTime.split(':')[0], getTime.split(':')[1]];
            if (Number(toTime[0]) <= Number(thisGetTime[0])) {
              if(
                Number(toTime[0]) == Number(thisGetTime[0])
                && Number(toTime[1]) > Number(thisGetTime[1])){
                count += 1;
              }else{
                count += 1;
              }
            }
            if (Number(toTime[0]) > Number(thisTime[0])) {
              starttime[i].timeText = false;
            } else if(Number(toTime[0]) == Number(thisTime[0])){
              if(Number(toTime[1]) > Number(thisTime[1])){
                starttime[i].timeText = false;
              }else{
                starttime[i].timeText = true;
              }
            }else{
              starttime[i].timeText = true;
            }
            this.getTime = '';
          }else{
            if (Number(toTime[0]) > Number(thisTime[0])) {
              starttime[i].timeText = false;
            } else if(Number(toTime[0]) == Number(thisTime[0])){
              if(Number(toTime[1]) > Number(thisTime[1])){
                starttime[i].timeText = false;
              }else{
                starttime[i].timeText = true;
                count += 1;
              }
            }else{
              starttime[i].timeText = true;
              count += 1;
            }
          }
          
        }
        for (var i = 0; i < tomorrowTime.length; i++) {
          let toTime = tomorrowTime[i].start_time.split(":");
          tomorrowTime[i].tomorrow = true;
        }
      }
      if (count == 0) {
        this.isindex = 0;
      } else {
        this.isindex = count - 1;
      }
      this.tomorrowTime = tomorrowTime;
      this.starttime = starttime;
      setTimeout(()=>{
        this.chuxian(this.isindex);
        let lateralScroll = document.getElementById('lateralScroll');
        let lateralItem = document.getElementById('lateralItem1');
        let scrollLeft = 0;
        if(lateralItem){
            scrollLeft = lateralItem.offsetWidth*(this.isindex);
        }
        lateralScroll.scrollLeft = scrollLeft;
      },30);
    },
    getStarttime() {
      let that = this;
      this.loading = true;
      let start_time = '';
      if(this.starttime[this.isindex]){
        start_time = this.starttime[this.isindex].start_time
      }else{
        return false;
      }
      //获取商品详情
      this.$commonPost({
        jydm: "flow_70013",
        flow_70013: {
          area_nbr: "103",
          user_nbr:that.userInfo.nbr||'',
          page_index: this.pageIndex*this.numPerPage,
          num_per_page: this.numPerPage,
          start_time: start_time,
          type: this.type
        }
      })
        .then(response => {
          let arr = [];
          if(response.commodity){
            if (response.commodity.length > 0) {
              arr = response.commodity;
            } else {
              arr.push(response.commodity);
            }
          }
          this.claerTimer&&clearInterval(this.claerTimer);
          this.times();
          this.claerTimer = setInterval(() => {
          this.times();
          }, 1000);
          
          if(arr.length<this.numPerPage){
            this.starttime[this.isindex].isEnd = true;
          }else{
            this.starttime[this.isindex].isEnd = false;
          }
          this.commodity_startTime = this.commodity_startTime.concat(arr);
          this.pageIndex += 1;
          if(arr.length<this.numPerPage){
            this.finished = true;
          }else{
            this.finished = false;
          }
          this.loading = false;
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    getPageData() {
      let that = this;
      this.$commonPost({
        jydm: "flow_70064",
        flow_70064: {
          area_nbr: "103",
          type: this.nbr
        }
      })
        .then(response => {
          let arr = [];
          if (response.fullTime) {
            if (response.fullTime.length > 0) {
              arr = response.fullTime;
            } else {
              arr.push(response.fullTime);
            }
            if(that.type==2){
             arr.map(item=>{
               item.tomorrow = true;
             })
            }
          }
          that.getswtich = true;
          that.lengths = arr.length;
          that.starttime = arr.concat(that.tomorrowTime);
          that.timer();
          that.commodity_startTime_Loading = false;
          that.noData = false;
          this.getStarttime();
        })
        .catch(err => {
          that.noData = false;
          that.getswtich = true;
          that.commodity_startTime_Loading = false;
          that.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    tomorrow(){
      let that = this;
      this.$commonPost({
        jydm: "flow_70064",
        flow_70064: {
          area_nbr: "103",
          type: 2
        }
      })
        .then(response => {
          let arr = [];
          if (response.fullTime) {
            if (response.fullTime.length > 0) {
              arr = response.fullTime;
            } else {
              arr.push(response.fullTime);
            }
            that.tomorrowTime = arr;
          }
          that.getPageData();
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
    handleScroll() {
      // 设备/屏幕高度
      let scrollTop = document.getElementById("scroll").scrollTop;
      if (scrollTop > 50) {
        this.toTopShow = true;
      } else {
        this.toTopShow = false;
      }
    },
    // 回到顶部动画
    toTopAnimate() {
      document.getElementById("scroll").scrollTop = 0;
    },
    getUserInfo(){
      // 用户的基本信息(身份)
      this.$commonPost({
        jydm: "flow_10003",
        flow_10003: {
          user_nbr: this.userInfo.nbr
        }
      })
        .then(response => {
          if (response.role == 0||response.role == 1) {
            this.roleText = "sell";
          } else if (response.role == 2) {
            this.roleText = "agent";
          } else if (response.role == 3) {
            this.roleText = "director";
          }
          if (response.new_role == 0 || response.new_role == 1) {
              this.roleNewText = "sell";
            } else if (response.new_role == 2) {
              this.roleNewText = "agent";
            } else if (response.new_role == 3) {
              this.roleNewText = "director";
            }
        })
        .catch(err => {
          this.$toast({
            message: err.message,
            duration: 2000
          });
        });
    },
  },

  watch: {
    $route(to, from) {
      if (
        from.path == "/information" ||
        from.path == "/placeorder" ||
        from.path == "/index"
      ) {
        this.keepAlive = true;
      } else {
        this.keepAlive = false;
      }
    }
  },
  deactivated(){
      clearInterval(this.claerTimer);
      this.claerTimer=null;
  },
  // 被缓存时任执行
  activated() {
    this.nbr = this.$route.query.nbr;
    this.type = this.$route.query.type;
    this.getTime  = this.$route.query.startTime;
    document
      .getElementById("scroll")
      .addEventListener("scroll", this.handleScroll, true);
      if (this.type == 1) {
        document.title = "限时秒杀";
        this.title = "限时秒杀";
      } else if (this.type == 2) {
        document.title = "明日预告";
        this.title = "明日预告";
      }
    this.initPage()
    if (!this.keepAlive) {
      //将高度滚动到原来离开页面的高度
      document.getElementById("scroll").scrollTop = this.scroll;
      this.times();
      this.claerTimer = setInterval(() => {
      this.times();
      }, 1000);
      return false;
    } else {
      (this.countdown = ""), (this.oonTime = ""), (this.pageIndex = 0);
      this.lengths = 0;
      this.isindex = 0;
      this.indexTime = 0;
      if(this.tomorrowTime != []){
        this.tomorrowTime = [];
      }
      this.starttime = [];
      this.commodity_startTime = [];
      if(this.type=='1'){
        return this.tomorrow();
      }
      this.getPageData();
    }
  },
  mounted() {
  },
  beforeRouteLeave(to, from, next) {
    this.scroll = document.getElementById("scroll").scrollTop;
    document
      .getElementById("scroll")
      .removeEventListener("scroll", this.handleScroll);
    next();
  }
};
</script>
<style lang="less" scoped >
.xianC{
  display:flex;
  align-items:center;
  height:100%;
  width: 0.04rem;
  transform: scale(0.5);
  transform-origin: left;
  .xian{
  height:.6rem;
  width:.04rem;
  background:#d8d8d8;
  
 }
}

.noDota {
  display: flex;
  justify-content: center;
  border: 0;
  width: 100%;
  height: calc(100vh - 0rem);
  background: #f5f5f5;
  span{
    margin-top: 3.78rem;
    color: #999;
    font-size: 0.32rem;
  }
}
.progress {
  width: 3.12rem;
  height: 0.28rem;
  border-radius: 0.16rem;
  margin-top: 0.13rem;
  background: #ff9c9c;
  overflow: hidden;
  position: relative;
}
.progressbg {
  height: 0.28rem;
  background-image: linear-gradient(90deg, #FE7202 0%, #FD3741 100%);
  border-radius: 0.16rem 0 0 0.16rem;
}
.progressbg span {
  font-size: 0.4rem;
  color: #ffffff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0.5);
  white-space: nowrap;
}
.time {
  width: 100%;
  height: 0.98rem;
  background: #ffffff;
  box-shadow: 0 0.04rem 0.08rem 0 rgba(0, 0, 0, 0.08);
  margin-top: 1.32rem;
  display: flex;
  justify-content: center;
  align-items: center;
  .timespan {
    font-size: 0.3rem;
    color: #333333;
  }
  .times {
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      width: 0.5rem;
      height: 0.5rem;
      font-size: 0.28rem;
      color: #ffffff;
      background: #000000;
      border-radius: 0.08rem;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 0.06rem;
    }
  }
}
.hide {
  display: none !important;
}
.toTop {
  position: fixed;
  right: 0.2rem;
  z-index: 999;
  bottom: 2rem;
  width: 0.8rem;
  height: 0.8rem;
  background: rgba(51, 51, 51, 0.5);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.toTop img {
  width: 0.4rem;
  height: 0.4rem;
}
.noData {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  background: #f5f5f5;
  position: absolute;
  top: 0;
  left: 0;
  span{
    color: #999;
  }
}
.noData img {
  width: 2.4rem;
  margin: 1.7rem auto 0.4rem;
}
.wrapper {
  width: 100%;
}
.fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
}
.lateral-sliding {
  display: flex;
  overflow-y: hidden;
  overflow-x: scroll;
  background-image: linear-gradient(-135deg, #fa5b4d 0%, #ff0e45 100%);
  .lateral-sliding-item {
    display: flex;
    .each-img {
      width: 1.62rem !important;
      height: 1.08rem !important;
      color: #ffffff;
      text-align: center;
    }
  }
}
.each-img-span {
  font-weight: 700;
  font-size: 0.32rem;
  margin-top: 0.24rem;
  display: inline-block;
}
.each-img-span1 {
  font-weight: 500;
  font-size: 0.2rem;
  margin-top: 0.16rem;
}
.each-img{
  .each-img-span{
    font-weight: bold;
    font-size: 0.4rem;
    margin-top: .2rem;
  }
  .each-img-span1{
    margin-top:0.12rem;
  }
}
// .active {
//   width: 0.6rem;
//   height: 0.04rem;
//   background: #fe0e4b;
//   border-radius: 2px;
//   margin-left: 0.5rem;
//   margin-top: 0.1rem;
// }
.lateral-sliding-rgba::-webkit-scrollbar {
  display: none;
}
.lateral-sliding::-webkit-scrollbar {
  display: none;
}
.content {
  width: 100%;
  height: calc(100vh - 2.3rem);
  box-sizing: border-box;
  overflow-y: auto;
}
.contents {
  width: 100%;
  height: calc(100vh - 1.32rem);
  box-sizing: border-box;
  overflow-y: auto;
  padding-bottom: 1rem;
}
.line {
  width: 100%;
  height: 0.24rem;
  background: #f8f9fb;
}
.content-box {
  width: 7.5rem;
  height: 2.58rem;
  display: flex;
  border-bottom: 1px #eee solid;
  &:last-child{
    border: 0;
  }
}
.content-box-tu {
  width: 2.6rem;
  height: 2.6rem;
  position: relative;
}
.content-box-tu img {
  width: 2.2rem;
  height: 2.2rem;
  margin-top: 0.19rem;
  margin-left: 0.3rem;
  object-fit: cover;
}
.content-box-tu .noNum {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0.17rem;
  left: 0.3rem;
  background: rgba(51, 51, 51, 0.3);
  height: 2.2rem;
  width: 2.2rem;
}
.content-box-tu .noNum img {
  width: 2rem;
  height: 1.5rem;
  margin-left: 0;
  margin-top: 0;
}
.content-box-information {
  width: 4.4rem;
  height: 2.58rem;
  margin-left: 0.2rem;
  position: relative;
}
.home-content-jmrt {
  width: 4.4rem;
  margin-top: 0.14rem;
  font-size: 0.24rem;
  line-height: 0.33rem;
  font-weight: 500;
  word-break: break-all;
  overflow: hidden;
}
.sigle-twoh {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.home-content-jmrm1 {
  height: 0.34rem;
  margin-top: 0.1rem;
  span {
    font-size: 0.2rem;
    color: #E52B25;
    margin-top: 0.16rem;
  }
}
.more-h {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.home-content-jmrm2 {
  margin-top: 0.35rem;
  box-sizing: border-box;
}
.home-content-jmrm2 .msj3 {
  font-size: 0.24rem;
  color: #E52B25;
  font-weight: bold;
}
.home-content-jmrm2 .msj {
  display: inline-block;
  font-weight: bold;
  font-size: 0.36rem;
  color: #333333;
}
.home-content-jmrm2 .msj1 {
  width: 2.68rem;
  height: 0.88rem;
  font-size: 0.56rem;
  border-radius: 0.44rem;
  display: inline-block;
  text-align: center;
  justify-content: center;
  line-height: 0.88rem;
  position: absolute;
  right: -.1rem;
  bottom: 0.36rem;
  color: #fff;
  background: #e73240;
  transform: scale(0.5);
  transform-origin: bottom right;
  box-sizing: border-box;
}
.msj1 span{
  display: flex;
  justify-content: center;
  align-items: center;
}
.msj1 span img{
  width: 0.48rem;
  height: 0.48rem;
}
.msj99{
  width: 2.96rem !important;
}
.home-content-jmrm2 .msj2 {
  width: 2.68rem;
  height: 0.88rem;
  font-size: 0.56rem;
  border-radius: 0.44rem;
  display: inline-block;
  text-align: center;
  line-height: 0.88rem;
  position: absolute;
  right: -.1rem;
  bottom: 0.36rem;
  color: #fff;
  background: #cccccc;
  transform: scale(0.5);
  transform-origin: bottom right;
  box-sizing: border-box;
}

.home-content-jmrm2 .msj i {
  font-family: 700;
  font-size: 0.24rem;
  color: #333333;
}
.home-content-jmrb {
  width: 3.14rem;
  line-height: 0.5rem;
  height: 0.5rem;
  overflow: hidden;
  color: #999;
  font-size: 0.24rem;
  text-decoration: line-through;
}
.each-img-x {
  width: 1.62rem !important;
  height: 1.08rem !important;
  text-align: center;
  opacity: 0.6;
  color: #ffffff;
}
.each-img-x span:nth-child(1) {
  font-family: 500;
  display: inline-block;
}
.each-img-x .each-img-span1 span:nth-child(1) {
  font-family: 500;
  font-size: 0.2rem;
}
.active > .span {
  margin-left: 0.7rem;
  background-color: #fe0e4b;
  width: 0.04rem;
  height: 0.04rem;
  border-radius: 0.08rem;
  display: inline-block;
  margin-bottom: 0.2rem;
}
</style>



// WEBPACK FOOTER //
// src/components/information/announcement.vue